import { Record } from 'immutable';

export type ApiDonorSemenFile = {
  id: number;
  image: { name: string}
};

const DonorSemenFileBase = Record({
  id: 0,
  name: "",
  image: File,
});

export class DonorSemenFile extends DonorSemenFileBase {
  constructor(apiDonorSemenFile?: ApiDonorSemenFile) {
    super({
      id: apiDonorSemenFile?.id,
      name: apiDonorSemenFile?.image.name,
    })
  }
}